import { Row, Col, Image } from 'react-bootstrap';
import { useStorage64 } from 'hooks';
import { MAPS_API_KEY } from 'constants/env';
import { AGENT_STAFF, CURRENT_GIFT_TABLE, PROFILE_DATA } from 'constants/storage64';
import truckIcon from 'assets/img/truck-icon.svg';
import editIcon from 'assets/img/edit-icon.svg';
import { cleanInvalidWords } from 'util/masks';

const AddressWidget = ({ address, handleShow, editAddress }) => {
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const [profileData] = useStorage64(PROFILE_DATA, {});
  const [agentStaff] = useStorage64(AGENT_STAFF, {});
  return (
    <Row className={`AddressInfo ${address.nombre ? 'show' : ''}`}>
      <Col md={6} lg={5}>
        <div className="AddressDetail">
          <Row>
            <Col xs={12} className="d-flex justify-content-between">
              <div className="d-flex align-items-center AddressDetail__title">
                <Image
                  className="icon"
                  src={truckIcon}
                  alt="Dirección de entrega"
                />
                <h5 className="m-0 font-weight-bold">Dirección de entrega</h5>
              </div>
              {editAddress && (
                <div className="d-flex align-items-start">
                  <Image
                    className="pointer"
                    src={editIcon}
                    alt="Editar dirección"
                    onClick={handleShow}
                  />
                </div>
              )}
            </Col>
          </Row>

          <Row className="mt-3 px-2">
            <Col xs={12} className="px-5 px-md-4 px-lg-5 ">
              <h6 className="AddressDetail__username text-primary mb-3">
              {cleanInvalidWords(agentStaff==null?profileData.nombreCompleto:decodeURIComponent(escape(storageGiftTable?.celebrate_labels?.length?storageGiftTable.celebrate_labels[0].label.value:'')))}
              </h6>
              <p>{address.nombre}</p>
              <p>
                {`${address.calle} ${address.numeroExterior}`}
                {address.numeroInterior}
              </p>
              <p>{`${address.colonia} ${address.ciudad}`}</p>
              <p>C. P. {address.codigoPostal}</p>
              <p className="my-2">Tel: {address.telefono}</p>
            </Col>
          </Row>
        </div>
      </Col>

      <Col md={6} lg={7}>
        <div className="AddressMap">
          {address.url && (
            <iframe
              title="maps"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps/embed/v1/place?key=${MAPS_API_KEY}&q=${address.url}`}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default AddressWidget;